import { clientIbkApi } from '@ibk/shared-config';
export const assistantChatApi = clientIbkApi.injectEndpoints({
    endpoints: build => ({
        sendAssistantChat: build.mutation({
            async queryFn(body, _api, _options, fetchWithBQ) {
                const response = await fetchWithBQ({ url: '/v1/assistente/chat', method: 'POST', body, timeout: 110000 });
                if (response.error)
                    return { error: response.error };
                const envelope = response.data;
                const result = envelope?.result;
                if (envelope?.success === false ||
                    envelope?.status !== 200 ||
                    result?.message?.role !== 'assistant' ||
                    typeof result.message.content !== 'string' ||
                    !result.message.content.trim() ||
                    !['stop', 'length'].includes(result.finishReason)) {
                    return { error: { status: 'CUSTOM_ERROR', error: 'Invalid assistant response' } };
                }
                return { data: { message: result.message, finishReason: result.finishReason } };
            },
        }),
    }),
});
export const { useSendAssistantChatMutation } = assistantChatApi;
